$(document).on('click', '[data-share]', function (e) {
    e.preventDefault();

    if ($('.mobile-menu-overlay').length){
        $('.mobile-menu-overlay').click();
    }

    var file = $(this).data("file"),
        title = $(this).data("title"),
        text = $(this).data("text"),
        url = $(this).data("url");

    navigator.share({title, text, url})
        .then(_ => console.log('Yay, you shared it :)'))
        .catch(error => console.log('Oh noh! You couldn\'t share it! :\'(\n', error));
});
